import { Configuration, LogLevel } from '@azure/msal-browser';

// Configuration MSAL pour l'authentification Entra ID
// Les variables sont lues depuis .env (préfixe REACT_APP_ pour CRA)
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID || ''}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    // sessionStorage évite les problèmes de tokens partagés entre onglets
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      },
    },
  },
};

// Scopes demandés lors de la connexion
// User.Read.All et Group.Read.All pour lire les infos utilisateurs et groupes
// Directory.ReadWrite.All pour modifier les comptes (désactiver, retirer des groupes)
// MailboxSettings.ReadWrite pour les paramètres de boîte mail (auto-reply)
export const loginRequest = {
  scopes: [
    'User.Read',
    'User.Read.All',
    'User.ReadWrite.All',
    'Group.Read.All',
    'GroupMember.ReadWrite.All',
    'Directory.ReadWrite.All',
    'MailboxSettings.ReadWrite',
    'UserAuthenticationMethod.ReadWrite.All',
    // passwordProfile exige cette permission dédiée : User.ReadWrite.All ne suffit
    // plus, même pour un Global Administrator (« Insufficient privileges »).
    'User-PasswordProfile.ReadWrite.All',
    // signInActivity (dernière connexion)
    'AuditLog.Read.All',
    // Retrait des licences
    'LicenseAssignment.ReadWrite.All',
  ],
};

// Scope de l'API exposée par l'App Registration, consommé par la Function Exchange.
// Il DOIT faire l'objet d'un token séparé : un token Graph porte l'audience
// graph.microsoft.com et Easy Auth le rejette (401). MSAL ne sait pas non plus
// mélanger deux ressources dans une même demande de token.
export const functionRequest = {
  scopes: [`api://${process.env.REACT_APP_CLIENT_ID || ''}/access_as_user`],
};

// Scopes pour les appels Graph API
export const graphScopes = {
  userRead: ['User.Read.All'],
  userWrite: ['User.ReadWrite.All'],
  groupRead: ['Group.Read.All'],
  groupWrite: ['GroupMember.ReadWrite.All'],
  directory: ['Directory.ReadWrite.All'],
  mailbox: ['MailboxSettings.ReadWrite'],
  authMethods: ['UserAuthenticationMethod.ReadWrite.All'],
};

// Rôles d'application de l'App Registration, attribués sans groupe quand une seule
// personne est concernée. Ils arrivent dans la claim `roles` de l'ID token, et
// Portal.Admin est aussi exigé côté serveur par la Function Exchange.
export const APP_ROLES = {
  admin: 'Portal.Admin',
  rh: 'Portal.RH',
};

// App RH distincte (SWA + EasyAuth, ses propres rôles) : le portail n'y donne qu'un accès
export const ONBOARDING_URL = 'https://witty-glacier-08ba08203.6.azurestaticapps.net';

// Groupes Entra ID par module — admin voit tout
// Configurer dans .env (REACT_APP_GROUP_*)
// Si tous sont vides → mode dev, tout accès autorisé
export const MODULE_GROUPS = {
  admin:      process.env.REACT_APP_GROUP_ADMIN       || '',
  offboarding: process.env.REACT_APP_GROUP_OFFBOARDING || '',
  eslSolum:   process.env.REACT_APP_GROUP_ESL_SOLUM   || '',
  odooImages: process.env.REACT_APP_GROUP_ODOO_IMAGES  || '',
};
